module.exports = __webpack_public_path__ + "img/concept-icon.e41e1eb0.svg";